import React from "react";

export const HudContext = React.createContext();
